<div class="fs-2 with-close" mat-dialog-title [ngClass]="titleClass">
    {{ title }}
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>

    <!-- Step: Raison de résiliation -->
    <ng-container *ngIf="step == 'reason'">
        <p class="semi-bold mb-3">Pouvez-vous nous dire la raison de votre départ ?</p>
        <div class="reason-list">
            <div class="reason-item" *ngFor="let reason of reasons"
                 [class.active]="selectedReason == reason.key"
                 (click)="selectReason(reason.key)">
                <span class="reason-key">{{ reason.key }}</span>
                <span class="reason-label">{{ reason.label }}</span>
            </div>
        </div>
    </ng-container>

    <!-- Step: Offre spéciale (bugs/fonctionnalités) -->
    <ng-container *ngIf="step == 'offer-bug'">
        <h2 class="mt-2 mb-3">Pouvons-nous nous rattraper ?</h2>
        <p>Envoyez-nous un descriptif du bug rencontré et nous le résoudrons le plus rapidement possible.</p>
        <p>Pour nous faire pardonner, nous vous proposons 20% de réduction sur votre prochain paiement si vous décidez de rester.</p>
        <p>Profitez de votre offre à durée limitée:</p>
        <b class="fs-3">20% de réduction sur votre prochain paiement</b>
        <button class="btn btn-primary btn-lg w-100 mt-3 mb-3" (click)="acceptOffer()" [disabled]="loading">
            <mat-spinner diameter="20" *ngIf="loading"></mat-spinner>
            <span *ngIf="!loading">Accepter cette offre</span>
        </button>
    </ng-container>

    <!-- Step: Félicitations (bien trouvé / projet abandonné) -->
    <ng-container *ngIf="step == 'congrats'">
        <h2 class="mt-2 mb-3">Nous sommes ravis que vous ayez pu concrétiser votre projet</h2>
        <p>LyBox vous permet également de suivre votre fiscalité dans le temps et d'ajuster vos simulations après les travaux et la mise en location.</p>
        <p>Pour conserver vos simulations et suivre votre nouveau projet, vous pouvez passer sur un forfait "basique" à partir de 9€/mois</p>
        <button class="btn btn-primary btn-lg w-100 mt-3 mb-3" (click)="goToChangePlan()">
            Modifier mon forfait
        </button>
    </ng-container>

    <!-- Step: Offre spéciale (autre service / budget) -->
    <ng-container *ngIf="step == 'offer-discount'">
        <h2 class="mt-2 mb-3">Vous voulez une bonne affaire ? 💰<br/>
            Restez et profitez de 20% sur votre prochain paiement.</h2>
        <p>Restez et profitez de 20% sur votre prochain paiement.</p>
        <p>Vous êtes éligible pour notre offre spéciale. Profitez de 20% de réduction sur votre prochain paiement</p>
        <p>Profitez de votre offre à durée limitée:</p>
        <b class="fs-3">20% de réduction sur votre prochain paiement</b>
        <button class="btn btn-primary btn-lg w-100 mt-3 mb-3" (click)="acceptOffer()" [disabled]="loading">
            <mat-spinner diameter="20" *ngIf="loading"></mat-spinner>
            <span *ngIf="!loading">Accepter cette offre</span>
        </button>
    </ng-container>

    <!-- Step: Feedback - Quel service -->
    <ng-container *ngIf="step == 'feedback-service'">
        <h2 class="mt-2 mb-3">Comment allez-vous faire maintenant ?</h2>
        <p>Quel service allez-vous utiliser et pourquoi avez-vous décidé de changer ?</p>
        <textarea class="form-control" rows="5" [(ngModel)]="feedback"
                  placeholder="Dites-nous vos commentaires..."></textarea>
    </ng-container>

    <!-- Step: Feedback - Amélioration -->
    <ng-container *ngIf="step == 'feedback-improve'">
        <h2 class="mt-2 mb-3">Que pouvons-nous améliorer ?</h2>
        <p>Nous avons besoin de votre retour honnête et de vos suggestions sur comment pouvons-nous améliorer LyBox.</p>
        <textarea class="form-control" rows="5" [(ngModel)]="feedback"
                  placeholder="Dites-nous vos commentaires..."></textarea>
    </ng-container>

    <!-- Step: Confirmation -->
    <ng-container *ngIf="step == 'confirmation'">
        <h2 class="mt-2 mb-3">Un petit instant, svp.</h2>
        <p>Nous vous recommandons vivement d'explorer les autres options au lieu de résilier. Si vous résiliez, votre abonnement restera actif jusqu'à la prochaine date d'anniversaire. Après cela, vous ne pourrez plus accéder aux nouvelles annonces, à vos biens enregistrés et vos simulations.</p>
        <div class="loss-box">
            <h2 class="mb-3">Si vous résiliez :</h2>
            <ul class="mb-0">
                <li><img class="me-1" src="assets/not.png" /> Perte de l'accès aux annonces immobilières.</li>
                <li><img class="me-1" src="assets/not.png" /> Perte de l'accès à vos simulations.</li>
                <li><img class="me-1" src="assets/not.png" /> Passer 7 fois plus de temps à chercher des biens.</li>
                <li><img class="me-1" src="assets/not.png" /> Perte de toutes vos réductions.</li>
                <li><img class="me-1" src="assets/not.png" /> Passage à des fonctionnalités limitées de LyBox.</li>
            </ul>
        </div>
    </ng-container>

    <!-- Step: Résiliation validée -->
    <ng-container *ngIf="step == 'cancelled'">

        <h2 class="mb-3">Votre abonnement a bien été résilié.</h2>
        <p>Vous ne serez plus prélevé.</p>
        <div class="text-center mt-4 mb-3">
            <div class="check-circle">
                <i class="fa fa-check-circle-o"></i>
            </div>
        </div>
        <h2 class="mb-3">Pouvez-vous nous aider une dernière fois ?</h2>
        <p>Vos retours sont essentiels pour nous aider à améliorer LyBox. J'aimerais discuter avec vous pour avoir vos idées suite à votre utilisation de LyBox.</p>
        <p class="semi-bold">Pouvez-vous m'accorder un appel de 30 min ?</p>
    </ng-container>

    <!-- Step: Offre acceptée -->
    <ng-container *ngIf="step == 'offer-accepted'">
        <div class="text-center mt-4 mb-3">
            <div class="check-circle">
                <i class="fa fa-check-circle-o"></i>
            </div>
        </div>
        <h2 class="text-center mb-3">Votre réduction a bien été appliquée.</h2>
        <p class="text-center">Nous sommes très heureux que vous ayez toujours parmi nous.</p>
    </ng-container>

</div>

<!-- Actions -->
<div mat-dialog-actions>

    <!-- Reason step -->
    <ng-container *ngIf="step == 'reason'">
        <button (click)="onNoClick()" class="btn btn-outline">Annuler</button>
        <button (click)="nextFromReason()" class="btn btn-primary" [disabled]="!selectedReason">Suivant</button>
    </ng-container>

    <!-- Offer bug -->
    <ng-container *ngIf="step == 'offer-bug'">
        <button (click)="goBack()" class="btn btn-outline">Retour</button>
        <button (click)="declineOffer()" class="btn btn-outline btn-right">Décliner l'offre</button>
    </ng-container>

    <!-- Congrats -->
    <ng-container *ngIf="step == 'congrats'">
        <button (click)="goBack()" class="btn btn-outline">Retour</button>
        <button (click)="declineOffer()" class="btn btn-outline btn-right">Résilier</button>
    </ng-container>

    <!-- Offer discount -->
    <ng-container *ngIf="step == 'offer-discount'">
        <button (click)="goBack()" class="btn btn-outline">Retour</button>
        <button (click)="declineOffer()" class="btn btn-outline btn-right">Décliner l'offre</button>
    </ng-container>

    <!-- Feedback service -->
    <ng-container *ngIf="step == 'feedback-service'">
        <button (click)="goBack()" class="btn btn-outline">Retour</button>
        <button (click)="nextFromFeedbackService()" class="btn btn-primary">Suivant</button>
    </ng-container>

    <!-- Feedback improve -->
    <ng-container *ngIf="step == 'feedback-improve'">
        <button (click)="goBack()" class="btn btn-outline">Retour</button>
        <button (click)="nextFromFeedbackImprove()" class="btn btn-primary">Suivant</button>
    </ng-container>

    <!-- Confirmation -->
    <ng-container *ngIf="step == 'confirmation'">
        <button (click)="goBack()" class="btn btn-outline">Retour</button>
        <button (click)="confirmCancel()" class="btn btn-primary" [disabled]="loading">
            <mat-spinner diameter="20" *ngIf="loading"></mat-spinner>
            <span *ngIf="!loading">Confirmer et résilier</span>
        </button>
    </ng-container>

    <!-- Cancelled -->
    <ng-container *ngIf="step == 'cancelled'">
        <button (click)="onNoClick()" class="btn btn-outline">Fermer</button>
        <button (click)="openCalendar()" class="btn btn-primary">Réserver un appel</button>
    </ng-container>

    <!-- Offer accepted -->
    <ng-container *ngIf="step == 'offer-accepted'">
        <button (click)="onNoClick()" class="btn btn-outline center">Fermer</button>
    </ng-container>

</div>
